import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";

import LookFeatureColorMatchCheckbox from "./lookFeatureColorMatchCheckbox";
import {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import withFeatureColorMatch from "../../../hocs/withFeatureColorMatch";


const LookFeatureColorMatch = (props) => {

  const {intl, sameColorFeatures, currentColorFeatures} = props;

  return (
    <div className={"lk-color-match" + (currentColorFeatures.length ? " lk-color-match--opened" : "")}>
      <div className="lk-color-match__title">
        <IconButton aria-label={intl.formatMessage({id:"iconButton.info"})}
                    className="look-icon look-icon--small look-icon--yellow">
          <ErrorIcon/>
        </IconButton>
        <p className="lm-notification__text">
          <FormattedMessage id="look.feature.matchColor.text"/>
        </p>
      </div>
      <div className="lk-color-match__checkbox">
        <LookFeatureColorMatchCheckbox currentColorFeatures={currentColorFeatures}
                                       sameColorFeatures={sameColorFeatures}
                                       checkboxText={"look.feature.matchColor.checkbox"}
                                       analyticsLabel={LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureMatchColorsCheckbox}/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  return {
    lookActiveFeature,
  };
};

export default injectIntl(
  connect(mapStateToProps)(
    withFeatureColorMatch(LookFeatureColorMatch)
  )
)
